import React, { useEffect, useState } from "react";
import {
  Spin,
  Button,
  Row,
  Col,
  Input,
  Space,
  Card,
  Typography,
  Modal,
  DatePicker,
} from "antd";
import {
  ArrowRight,
  CircleAlert,
  ExternalLink,
  Medal,
  Search,
} from "lucide-react";
import { FONT } from "constants/index";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import { ColumnsUserAqua } from "./columns-table";
import DrawerApp from "components/drawer-app";
import {
  getReviewUserById,
  getSprintUserById,
  deleteSprint,
} from "services/review/review-service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import moment from "moment";
import { getReviewStats, getUsersReviewsAqua } from "services/aquatic/aquatic-service";
import FormNewUserReviewAqua from "./reviews-drawer-new-review-aqua";
import FormUserComparationAqua from "./reviews-drawer-comparation-aqua";
import FormNewUserReviewMultipleAqua from "./reviews-drawer-new-review-multiple-aqua";
import ReviewsStats from "./reviews-stats";
import useBreakpoint from "hooks/useBreakpoint";
import { listMinWidth } from "util/responsive";
import ResponsiveDataList from "components/responsive-data-list";

dayjs.extend(customParseFormat);
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;

const { Text } = Typography;
const { confirm } = Modal;

const ReviewsClientAqua = () => {
  const { isMobile, width } = useBreakpoint();
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(null);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openComparation, setOpenComparation] = useState(false);
  const [editId, setEditId] = useState(null);
  const [imgAvatar, setImgAvatar] = useState("");
  const formRefRecord = React.useRef(null);
  const [dataDrawer, setDataDrawer] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [openDrawers, setOpenDrawers] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [rengeSearch, setRengeSearch] = useState(null);
  const [stats, setStats] = useState({users: 0, reviews: 0});

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoading(true);
    getData();
  }

  async function getData() {
    let obj = {
      search: search,
    };

    if (search == null || search == "") {
      obj = {};
    }
    if (rengeSearch && rengeSearch.length == 2) {
      obj.start = rengeSearch[0]?.format(dateFormat);
      obj.end = rengeSearch[1]?.format(dateFormat);
    }

    try {
      const [reviews, reviewsStats] = await Promise.all([
        getUsersReviewsAqua(obj),
        getReviewStats("ADULT"),
      ]);

      const formattedData = reviews.map((item) => ({
        ...item,
        record: record,
        result: result,
        comparation: comparation,
        edit: edit,
      }));

      setData(formattedData);
      setStats(reviewsStats)
    } catch (err) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }
  const showDrawer = () => {
    setOpen(true);
  };

  const showDrawerComparation = () => {
    setOpenComparation(true);
  };
  const showDrawerResult = () => {
    setOpenResult(true);
  };

  const showDrawerRecord = () => {
    setOpenRecord(true);
  };
  const onClose = () => {
    setEditId(null);
    setOpen(false);
    refreshData();
  };
  const onCloseDrawers = () => {
    setOpenDrawers(false);
    refreshData();
    setSelectedRowKeys([]);
    setIsEdit(false);
  };

  const onCloseComparation = () => {
    setEditId(null);
    setDataDrawer({ reviews: [] });
    setOpenComparation(false);
    refreshData();
  };

  function edit(row) {
    setEditId(row.id);
    setImgAvatar(row.img);
    showDrawer();
  }
  function comparation(row) {
    setEditId(row.id);
    setImgAvatar(row.img);
    setLoading(true);
    var funcGet = getReviewUserById;
    funcGet(row.id)
      .then((res) => {
        setDataDrawer(res);
        setLoading(false);
        showDrawerComparation();
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function editSprint(row) {
    setLoading(true);
    setEditSprintId(row.id);
    setTimeout(() => {
      formRefRecord.current?.setFieldsValue({
        date: row.sprintDate ? dayjs(row.sprintDate) : null,
        typeRecord: row.typeRecord,
        record: row.record,
      });
      setLoading(false);
    }, 300);
  }
  function deleteSprintItem(row) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Tem certeza que deseja deletar o sprint do dia '
            {moment(row.sprintDate).format("DD/MM/YYYY")}' ?
          </span>
        </div>
      ),
      icon: null,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoading(true);
        deleteSprint(row.id)
          .then(() => {
            getDataSprintUserById(editId, row.name);
            notificationSucess();
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }
  function record(row) {
    setLoading(true);
    setEditId(row.id);
    setImgAvatar(row.img);
    getDataSprintUserById(row.id, row.name);
  }
  function getDataSprintUserById(id, name) {
    getSprintUserById(id)
      .then((res) => {
        setTimeout(() => {
          res = res.map((obj) => ({
            ...obj,
            edit: editSprint,
            delete: deleteSprintItem,
          }));
          setDataSprint(res);
          formRefRecord.current?.setFieldsValue({
            name: name,
          });
          setLoading(false);
        }, 300);
        showDrawerRecord();
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function result(row) {
    setEditId(row.id);
    setImgAvatar(row.img);

    setLoading(true);
    getReviewUserById(row.id)
      .then((res) => {
        setDataDrawer(res);
        setLoading(false);
        showDrawerResult();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const onSelectChange = (newSelectedRowKeys) => {
    const newSelectedKeys = [...selectedRowKeys];

    newSelectedRowKeys.forEach((key) => {
      if (!newSelectedKeys.includes(key)) {
        newSelectedKeys.push(key);
      }
    });

    const allKeys = newSelectedKeys.filter((key) =>
      newSelectedRowKeys.includes(key)
    );
    if (allKeys.length <= 6) {
      setSelectedRowKeys(allKeys);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    columnWidth: "10%",
    preserveSelectedRowKeys: true,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const mountFilter = () => {
    return (
      <Row
        className="reviews-filter-row"
        gutter={[16, 16]}
        style={{ padding: "10px", alignItems: "center" }}
      >
        <Col xs={24} md={7} lg={6}>
          <Input
            allowClear
            value={search ?? ""}
            placeholder="Pesquisar Aluno"
            onChange={(e) => setSearch(e.target.value)}
            prefix={<Search size={18} color="#e0e0e0" />}
            style={{ width: "100%" }}
            onPressEnter={refreshData}
          />
        </Col>
        <Col xs={24} md={10} lg={9}>
          <RangePicker
            style={{ width: "100%", height: 40 }}
            placeholder={["Data Inicial", "Data Final"]}
            format={dateFormat}
            onChange={(value) => {
              setRengeSearch(value);
            }}
          />
        </Col>
        <Col xs={24} md={5} lg={4}>
          <Button
            style={{ fontFamily: FONT, width: "100%" }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Col>
        {hasSelected && (
          <Col xs={24}>
            <Space wrap>
              <Text style={{ fontFamily: FONT }}>
                {selectedRowKeys.length} alunos selecionados
              </Text>
              <Button
                style={{ fontFamily: FONT }}
                type="primary"
                icon={
                  <ExternalLink
                    size={18}
                    style={{ marginBottom: "-3px", marginRight: "7px" }}
                  />
                }
                onClick={() => setOpenDrawers(true)}
              >
                Abrir Todos
              </Button>
              <Button
                style={{
                  fontFamily: FONT,
                  backgroundColor: "#09ac9c",
                }}
                type="primary"
                icon={
                  <ExternalLink
                    size={18}
                    style={{ marginBottom: "-3px", marginRight: "7px" }}
                  />
                }
                onClick={() => {
                  setIsEdit(true);
                  setOpenDrawers(true);
                }}
              >
                Editar Todos
              </Button>
            </Space>
          </Col>
        )}
      </Row>
    );
  };
  return (
    <div className="container-reviews-client">
      <ReviewsStats stats={stats} isLoading={loading} />
      <Spin size="large" spinning={loading}>
        {mountFilter()}
        <Row gutter={[24, 24]} style={{ marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{
              flex: "1 1 500px",
              minWidth: listMinWidth(isMobile),
            }}
          >
            <Card
              id="card-table"
              className="card-table-list"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Medal
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                      Avaliações dos Alunos
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <ResponsiveDataList
                isMobile={isMobile}
                forceCardLayout
                cardVariant="profile"
                rowKey={"id"}
                columns={ColumnsUserAqua(false)}
                dataSource={data}
                rowSelection={rowSelection}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                locale={{
                  emptyText: "Sem registro",
                }}
              />
            </Card>
          </Space>
        </Row>
      </Spin>

      <DrawerApp
        open={open}
        onClose={onClose}
        title={"Nova Avaliação"}
        body={
          <FormNewUserReviewAqua
            user={data.find((item) => item.id == editId)}
            onClose={onClose}
            lastReview={data.find((item) => item.id == editId)?.lastReview}
          />
        }
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openComparation}
        onClose={onCloseComparation}
        title={"Avaliações"}
        body={
          <FormUserComparationAqua
            dataDrawer={dataDrawer}
            imgAvatar={imgAvatar}
          />
        }
        size={"large"}
        isOnlyView={true}
      />

      {openDrawers && (
        <DrawerApp
          open={openDrawers}
          onClose={onCloseDrawers}
          title={isEdit ? "Editar Avaliação" : "Nova Avaliação"}
          body={
            <FormNewUserReviewMultipleAqua
              data={data.filter((item) => selectedRowKeys.includes(item.id))}
              onClose={onCloseDrawers}
              isEdit={isEdit}
            />
          }
          isOnlyView={true}
          size={"large"}
        />
      )}
    </div>
  );
};
export default ReviewsClientAqua;
